import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {MemberModel} from '../../../../models/user.model';

@Injectable({
    providedIn: 'root'
})

export class UsersMultiselectSync {

    private observer: Subject<boolean> = new Subject<boolean>();
    private observeUsers: Subject<MemberModel> = new Subject<MemberModel>();

    public get newUsers(): Observable<any> {
        return this.observeUsers.asObservable();
    }

    public syncUsers(): Observable<any> {
        return this.observer.asObservable();
    }

    public sendUpdate(): void {
        this.observer.next(true);
    }

    public sendNewUser(user: MemberModel): void {
        this.observeUsers.next(user);
    }
}
